import { ref } from 'vue';

// Inicializar el estado desde localStorage
const storedConsent = localStorage.getItem('cookieConsent');
export const consentGranted = ref(storedConsent === 'granted');
export const consentAnswered = ref(storedConsent !== null);

// Declarar la función gtag en la raíz del módulo para cumplir con ESLint (no-inner-declarations)
window.dataLayer = window.dataLayer || [];
function gtag() {
  window.dataLayer.push(arguments);
}

// Función para actualizar el consentimiento
export function updateConsent(granted) {
  localStorage.setItem('cookieConsent', granted ? 'granted' : 'denied');
  consentGranted.value = granted;
  consentAnswered.value = true;

  // Actualizar Google Consent Mode v2
  gtag('consent', 'update', {
    'ad_storage': granted ? 'granted' : 'denied',
    'analytics_storage': granted ? 'granted' : 'denied',
    'ad_user_data': granted ? 'granted' : 'denied',
    'ad_personalization': granted ? 'granted' : 'denied'
  });
}

// Si ya existe consentimiento previo, lo aplicamos en la inicialización
if (storedConsent !== null) {
  gtag('consent', 'update', {
    'ad_storage': storedConsent === 'granted' ? 'granted' : 'denied',
    'analytics_storage': storedConsent === 'granted' ? 'granted' : 'denied',
    'ad_user_data': storedConsent === 'granted' ? 'granted' : 'denied',
    'ad_personalization': storedConsent === 'granted' ? 'granted' : 'denied'
  });
}
